import { MantineProvider, DirectionProvider, createTheme } from "@mantine/core";
import { DatesProvider } from "@mantine/dates";
import type { ReactNode } from "react";
import "dayjs/locale/ar";
import { useLocale } from "../../i18n";

const theme = createTheme({
  fontFamily: '"GT America Arabic", Inter, "Segoe UI", Tahoma, system-ui, sans-serif',
  primaryColor: "mzn", defaultRadius: "md",
  colors: { mzn: ["#eef2ff", "#dce4fb", "#b8c9f4", "#93acec", "#6c8ae0", "#5072d5", "#3e60cb", "#3153b7", "#2b499f", "#203052"] },
});
export function InputProvider({ children }: { children: ReactNode }) {
  const { lang } = useLocale();
  return <DirectionProvider initialDirection={lang === "ar" ? "rtl" : "ltr"}>
    <MantineProvider theme={theme} forceColorScheme="light" withGlobalClasses={false}>
      <DatesProvider settings={{ locale: lang, firstDayOfWeek: lang === "ar" ? 6 : 1 }}>{children}</DatesProvider>
    </MantineProvider>
  </DirectionProvider>;
}
